import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import NHFetch from '../../../../utils/NHFetch';

import styles from '../styles.css';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 5 * 1000; //轮询时间间隔

/**
 * 底部统计板块
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-09-30
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            errCount: 0, //连续请求错误次数
            data: [], //最新刷脸报到学生
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 获取报到统计数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/rlsb/getNewlyReportedStudents', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: 0, data: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    render() {

        const { rem } = this.props;

        let { data = [] } = this.state;
        let opacityRate = 1;

        if (data.length > 0) {
            opacityRate = 1 / data.length;
        }

        return (
            <div className={styles.listBox}>
                <p>最新刷脸报到学生</p>
                <div className={styles.list}>
                    <table>
                        <tbody>
                            {
                                data.length > 0 && data.map((item, index) =>
                                    <tr key={index} style={{ opacity: `${index > 0 ? 1 - opacityRate * index : 1}` }}>
                                        <td width='100' height='30'>
                                            <span className={classNames(styles.span_c1,styles.span_c)}>{item.xm}</span>
                                        </td>
                                        <td width='180'>
                                            <span className={classNames(styles.span_c2,styles.span_c)}>{item.xymc}</span>
                                        </td>
                                        <td width='100'>
                                            <span className={classNames(styles.span_c2,styles.span_c)}>{item.bdsj}</span>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./components/face/scan/rightBox/bottom.js